

































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import Verifier from '@/components/scanner/Verifier.vue';


@Component({
  components: {
    Verifier,
  },
})
export default class LandingPageLeftSide extends Vue {
    public verify: boolean = false;
    get signers(): string[] {
        return this.$store.getters.getPublicKeys;
    }

    get locale() {
        return this.$store.getters.locale;
    }
}
